import React, { useEffect, useState } from "react";
import { Container, Row, Col, Badge } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { Card } from "shards-react";
import swal from "sweetalert2";
import { primaryColor } from "../../config/colors";
import { strings } from "../../localization";
// import "./FoodSummary.css";
import {
  formateNumber,
  getFormattedDateTime,
  getKOTStatusIcon,
  navigatePage,
  ORG_ID,
  TABLE_ID,
} from "../../config";
import Header from "../../components/Header";
import OrderStatusContainer from "../../components/OrderStatusContainer";
import Loading from "../../components/Loading";
import Navbar from "../../components/navbar/Navbar";
import { getCurrentOrPastOrderDetail } from "../../api/ApiServices";
window.Swal = swal;

const OrderDetail = ({ match, location }) => {
  console.log("DEBUG match in order detail page", match);
  console.log("DEBUG location in order detail page", location);
  const { routeName, orderData } = location.state || {};

  const [orderDetails, setOrderDetails] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const getOrderDetails = () => {
    if (match.params) {
      // setOrderId(match.params.id);
      // setTimeout(() => {
      //   setOrderDetails(orderData)
      //   setIsLoading(false);
      // }, [2000]);
      setIsLoading(true);
      getCurrentOrPastOrderDetail(match.params.id)
        .then(async (res) => {
          const parsedJson = await res.json();
          if (res.status === 200) {
            if (parsedJson) {
              let obj = parsedJson.data;
              obj = Object.assign({ id: parsedJson._id }, obj);
              setOrderDetails(obj);
            }
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log("catch block error while getting order detail", error);
          setIsLoading(false);
        });
    }
  };

  const onBackButtonClicked = () => {
    navigatePage(routeName);
  };

  const getTotalAmount = () => {
    const propina = orderDetails.propina || "";
    let totalAmount = orderDetails.totalAmount;
    let propinaAmount = 0;
    let isPropinaEnabled = false;
    if (propina) {
      isPropinaEnabled = propina.checked;
      propinaAmount = propina.amount;
    }
    if (isPropinaEnabled) {
      totalAmount += propinaAmount;
    }
    propinaAmount = formateNumber(propinaAmount);
    totalAmount = formateNumber(totalAmount);
    return {
      isPropinaEnabled,
      propinaAmount,
      totalAmount,
    };
  };

  useEffect(() => {
    getOrderDetails();
  }, []);

  console.log("orderDetails", orderDetails);

  return (
    <Container fluid className="p-0 d-flex flex-column vh-100 overflow-hidden">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <Navbar />
          <Card className="flex-grow-1 d-flex flex-column overflow-hidden shadow-sm radius-0">
            {/* 🔝 Page Title */}
            <div className="colHeaderContainer p-0">
              <div className="bg-primary">
                {/* Header component */}
                <Header
                  onBackButtonClicked={onBackButtonClicked}
                  // title={strings.order_detail}
                  title={orderDetails.orderID}
                  backButtonExtraStyle={"mb-3 py-2"}
                />
              </div>

              <Row className="align-items-center mb-3 px-2">
                <Col xs="6" className="truncate-multiline">
                  <p className="text-muted fw-bold p-0 m-0">
                    {/* {getFormattedDateTime(orderDetails.date)} */}
                    {orderDetails.orderDate} {orderDetails.orderTime}
                  </p>
                </Col>
                <Col xs="6" className="d-flex justify-content-end">
                  <OrderStatusContainer status={orderDetails.status} />
                </Col>
              </Row>

              {/* 📊 Column Titles */}
              <Row className="text-muted medium fw-semibold px-3">
                <Col xs={6} md={6}>
                  {strings.item}
                </Col>
                <Col xs={3} md={3} className="text-center">
                  {strings.qty}
                </Col>
                <Col xs={3} md={3} className="text-end">
                  {strings.price}
                </Col>
              </Row>
            </div>

            <div className="colItemsContainer overflow-auto">
              {orderDetails &&
                orderDetails.dataArray &&
                orderDetails.dataArray.map((item) => (
                  <Row className="foodItemRowContainer">
                    {/* Column 1: Food Info */}
                    <Col xs={6} md={6}>
                      <div>
                        <div className="d-flex align-items-start">
                          <strong
                            className="truncate-multiline"
                            style={{ fontWeight: "bold", fontSize: 16, marginRight: 3, }}
                          >
                            {item.name}
                          </strong>
                          {getKOTStatusIcon(item.kotStatus, 18, "black")}
                        </div>
                        <div className="medium truncate-multiline">
                          {item.description}
                        </div>
                        {item.note && (
                          <p
                            className="truncate-multiline text-muted small"
                            style={{
                              textDecoration: "none",
                              width: "100%",
                              fontSize: 14,
                            }}
                          >
                            <i
                              className="material-icons"
                              style={{
                                fontSize: 16,
                                color: primaryColor,
                                marginRight: 3,
                              }}
                            >
                              description
                            </i>
                            {item.note}
                          </p>
                          // </div>
                        )}
                      </div>
                    </Col>

                    {/* Column 2: Quantity Control */}
                    <Col
                      xs={3}
                      md={3}
                      className="d-flex justify-content-center"
                    >
                      <strong>x{item.quantity}</strong>
                    </Col>

                    {/* Column 3: Price */}
                    <Col xs={3} md={3} className="text-end">
                      <strong>
                        {formateNumber(item.price ? item.price : 0)}
                      </strong>
                    </Col>
                  </Row>
                ))}
            </div>

            {/* 💵 Price Summary + Button (Fixed) */}
            <div
              className="position-fixed bottom-0 start-0 end-0 bg-white p-3 border-top"
              style={{ zIndex: 1030 }}
            >
              {/* <Row className="mb-2">
              <Col className="text-start" style={{fontSize: '14px'}}>{strings.subtotal}</Col>
              <Col className="text-end" style={{fontSize: '14px'}}>${orderDetails.subtotal}</Col>
            </Row>
            <Row className="mb-2">
              <Col className="text-start">IVA (19%)</Col>
              <Col className="text-end">${orderDetails.iva}</Col>
            </Row> */}
              {orderDetails.propina && orderDetails.propina.checked && (
                <Row className="mb-3">
                  <Col className="text-start fw-bold">{strings.tip}(10%)</Col>
                  <Col className="text-end fw-bold">
                    {formateNumber(
                      orderDetails.propina.amount
                        ? orderDetails.propina.amount
                        : 0
                    )}
                  </Col>
                </Row>
              )}
              <Row className="mb-3">
                <Col className="text-start fw-bold">{strings.total}</Col>
                <Col className="text-end fw-bold">
                  {formateNumber(
                    orderDetails.totalAmount
                      ? orderDetails.totalAmount
                      : 0
                  )}
                </Col>
              </Row>
            </div>
          </Card>
        </>
      )}
    </Container>
  );
};

export default withRouter(OrderDetail);
